import api from "../../api"
import { TenantLastActivity } from "./tenantLastActivityModel"

export const proposalsEndpoint = `/web/tenant-last-activity`

export const getTenantLastActivity = async (): Promise<TenantLastActivity[]> => {
  return (await api.get<TenantLastActivity[]>(proposalsEndpoint)).data
}